import type { WorkToastItem } from "@/stores/work-toast-store";
import { useT } from "@/i18n";
import { toastsMessages } from "@/i18n/messages/toasts";
import { ToastCard } from "./toast-card";
import { useWorkToastNames } from "./use-work-toast-names";
import { WorkToastLogo } from "./work-toast-identity";
import { workToastTitle } from "./work-toast-view";

/** Frozen copy of an answered question, shown for 1.5 s (spec §7). */
export function WorkToastAnsweredCard({
  item,
  onDone,
}: {
  item: WorkToastItem;
  onDone: () => void;
}) {
  const { projectName, taskTitle, conversationTitle } = useWorkToastNames(item);
  const t = useT(toastsMessages);
  const logo = <WorkToastLogo item={item} />;
  return (
    <ToastCard
      toastKey={item.key}
      state="answered"
      logo={logo}
      title={workToastTitle(item, projectName, taskTitle, conversationTitle)}
      subtitle={t("answered")}
      menuItems={[]}
      onCollapse={onDone}
      focusOnMount={false}
    >
      <p
        className="text-appkit-caption text-muted"
        data-testid="work-toast-answered"
      >
        {item.question?.question ?? ""}
      </p>
    </ToastCard>
  );
}
